import { createContext } from "utils/react/createContext";
import { IModalProps } from "../";

export type IModalContext = Omit<IModalProps, "children">;

export const [ModalContext, useModalContext] = createContext<IModalContext>();
